import { FC } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Card, CardContent, Grid } from 'lib/components';
import { RegistrationStep } from '../../store';
import {
  GettingStartedContent,
  GettingStartedLayout,
  GettingStartedMealsEveryWeekFooter,
  PreferencesForm
} from '../../components';

const PreferencesPage: FC = () => (
  <GettingStartedLayout className="getting-started-preferences" step={RegistrationStep.preferences}>
    <GettingStartedContent>
      <Grid>
        <div className="col-span-12 lg:col-span-10 lg:col-start-2">
          <Card className="lg:bg-getting-started bg-[length:157px_auto] bg-repeat-y bg-right-top mb-32 lg:mb-20 !overflow-visible relative">
            <CardContent className="lg:!pr-[280px]">
              <h2>Personalize Your Box</h2>
              <PreferencesForm />
            </CardContent>
            <StaticImage
              className="!absolute !hidden lg:!block right-[-6.5%] top-1/2 -translate-y-1/2 lg:max-w-[320px]"
              src="../../images/sambal-shrimp-dish.png"
              alt="A delicious plate of carrots, cucumbers, jalapeños, and shrimp."
              placeholder="blurred"
            />
          </Card>
        </div>
      </Grid>
    </GettingStartedContent>

    <div className="bg-primary h-20 relative lg:hidden">
      <StaticImage
        className="z-10 !absolute left-1/2 bottom-0 -translate-x-1/2 max-w-[180px]"
        src="../../images/sambal-shrimp-dish.png"
        alt="A delicious plate of carrots, cucumbers, jalapeños, and shrimp."
        placeholder="blurred"
      />
    </div>
    <GettingStartedMealsEveryWeekFooter className="!mt-0" />
  </GettingStartedLayout>
);

export default PreferencesPage;
